// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"650":"0780cc26","712":"b4ee6a8a","851":"ed815e19"}[chunkId] + ".chunk.css";
};